var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModernSelect',{staticStyle:{"min-width":"150px"},attrs:{"value":_vm.value,"options":_vm.options,"disabled":_vm.userTypeIds === null || _vm.userTypeIds.length < 1},on:{"input":_vm.onValueChange}})}
var staticRenderFns = []

export { render, staticRenderFns }